import React from "react";
import DosageModal from "./DosageModal";
import { targetCropConcernThunk } from "../../../../../store/thunks/InventoryThunk";
import { useDispatch } from "react-redux";

const CropTab = ({ name, detail, productId }) => {
  const dispatch = useDispatch();

  return (
    <div className="custom-radio-button-black">
      {detail?.targetCrops?.[name]?.map((annual_crops, index) => {
        return (
          <React.Fragment key={annual_crops?.id || index}>
            <label
              key={index.toString()}
              className="status"
              data-toggle="modal"
              data-target={`#annual_modal_${annual_crops?.id}`}
              onClick={(e) => {
                e.preventDefault();
                dispatch(
                  targetCropConcernThunk({
                    productId: productId,
                    cropId: annual_crops?.id,
                  })
                );
              }}
            >
              <input type="radio" name="radio" />
              <div className="box">
                <span>{annual_crops?.name?.en}</span>
              </div>
            </label>
            {/*Usage & Dosage Modal Start*/}
            <DosageModal
              modalId={`annual_modal_${annual_crops?.id}`}
              cropName={annual_crops?.name?.en}
            />
            {/*Usage & Dosage Modal End*/}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default CropTab;
